<template>
	<div class="empty_container">
		<div class="w-[120px] h-[120px] mb-[24px]">
			<img src="@/assets/icons/local_mall.png" />
		</div>

		<div class="cart_empty">{{ $t("pages.cart.cart_is_empty") }}</div>
		<NuxtLink to="/textiles">
			<Button
				class="tg-btn"
				color="primary"
				size="large"
			>
				{{ $t("pages.cart.browse_catalog") }}
			</Button>
		</NuxtLink>
	</div>
</template>

<style lang="scss" scoped>
.empty_container {
	@apply h-full flex flex-col items-center justify-center;

	.cart_empty {
		@apply mb-[32px] text-[40px] leading-[48px] font-medium text-neutral-600;
	}
}
</style>
